import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import dotsquares from "../images/dotsquares.webp";
import pericent from "../images/pericent.png";
import sonata from "../images/sonata.svg";
import dreamsoft from "../images/dreamsoft.jpg";
import keyboard from "../images/keyboard.png";
import "./Experience.css";
import ExpCardView from "./expcardview";
class ExperienceView extends Component {
  state = {};
  render() {
    return (
      <>
        <div id="experience" style={{backgroundImage:`url(${keyboard})`,backgroundSize:'cover' }}>
        <Container fluid>
          <div style={{ textAlign: "center", margin: "2rem" }}>
            <span className="work-title">Work Experience</span>
          </div>
          <Row className="roomfac fontReg bottom-margin">
            <Col xs={12} sm={6} md={3} className="d-flex">
              <ExpCardView
                image={sonata}
                title={"Sonata Software"}
                subtitle={"Jun, 2022 - current"}
              />
            </Col>
            <Col xs={12} sm={6} md={3} className="d-flex">
              <ExpCardView
                image={dotsquares}
                title={"Dotsquares"}
                subtitle={"Oct, 2017 - Jun, 2022"}
              />
            </Col>
            <Col xs={12} sm={6} md={3} className="d-flex">
              <ExpCardView
                image={dreamsoft}
                title={"Dreamsoft4u"}
                subtitle={"April, 2016 - Oct, 2017"}
              />
            </Col>
            <Col xs={12} sm={6} md={3} className="d-flex">
              <ExpCardView
                image={pericent}
                title={"Pericent"}
                subtitle={"Jun, 2015 - April, 2016"}
              />
            </Col>
          </Row>
        </Container>
        </div>
      </>
      // <div className="container row">

      // </div>
    );
  }
}

export default ExperienceView;
